import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  return (
    <div className={`bg-gray-800 border border-gray-700 rounded-xl p-6 ${hover ? 'hover:border-gray-600 transition-colors duration-200' : ''} ${className}`}>
      {children}
    </div>
  );
}